import memoizeOne from "memoize-one";

import { ITEM_CARD_LIST_HEADER_HEIGHT } from "../../constants";
import { scalePixelsToFontSize } from "../../constants/styles/dimensions";

const getItemCardListContainerContextValue = memoizeOne((propsContainerRect, fontSize) => {
  let headerHeight = scalePixelsToFontSize(ITEM_CARD_LIST_HEADER_HEIGHT, fontSize);
  //#!if harvard === true
  headerHeight = 0;
  //#!endif
  let containerRect = propsContainerRect;
  if (headerHeight) {
    containerRect = containerRect.merge({
      height: containerRect.height - headerHeight,
      top: containerRect.top + headerHeight
    });
  }
  return { containerRect };
});

export { getItemCardListContainerContextValue };
